import { currencyToFloat } from "./converts";
import { validaCnpj, validaCpf } from "./helpers";

class Validation {
  constructor(Yup = null) {
    this.Yup = Yup;
    if (Yup) {
      this.configureAddMethods();
    }
  }

  cpfCnpj(val) {
    if (!val) return false;
    val = val.replace(/\D/g, "");

    if (val.length === 11) {
      return validaCpf(val);
    } else {
      return validaCnpj(val);
    }
  }

  slug(val) {
    if (!val) return false;
    const pattern = /^[a-z-]+$/g;
    if (pattern.test(val)) {
      return true;
    } else {
      return false;
    }
  }

  colorHex(val) {
    if (!val) return true;

    if (val.length === 7) {
      const pattern = /^#[A-Fa-z0-9]{3}$|^#[A-Fa-z0-9]{6}$/gi;
      if (pattern.test(val)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  uf(val) {
    if (!val) return true;
    const ufs = [
      { nome: "Acre", sigla: "AC" },
      { nome: "Alagoas", sigla: "AL" },
      { nome: "Amapá", sigla: "AP" },
      { nome: "Amazonas", sigla: "AM" },
      { nome: "Bahia", sigla: "BA" },
      { nome: "Ceará", sigla: "CE" },
      { nome: "Distrito Federal", sigla: "DF" },
      { nome: "Espírito Santo", sigla: "ES" },
      { nome: "Goiás", sigla: "GO" },
      { nome: "Maranhão", sigla: "MA" },
      { nome: "Mato Grosso", sigla: "MT" },
      { nome: "Mato Grosso do Sul", sigla: "MS" },
      { nome: "Minas Gerais", sigla: "MG" },
      { nome: "Pará", sigla: "PA" },
      { nome: "Paraíba", sigla: "PB" },
      { nome: "Paraná", sigla: "PR" },
      { nome: "Pernambuco", sigla: "PE" },
      { nome: "Piauí", sigla: "PI" },
      { nome: "Rio de Janeiro", sigla: "RJ" },
      { nome: "Rio Grande do Norte", sigla: "RN" },
      { nome: "Rio Grande do Sul", sigla: "RS" },
      { nome: "Rondônia", sigla: "RO" },
      { nome: "Roraima", sigla: "RR" },
      { nome: "Santa Catarina", sigla: "SC" },
      { nome: "São Paulo", sigla: "SP" },
      { nome: "Sergipe", sigla: "SE" },
      { nome: "Tocantins", sigla: "TO" },
    ];

    if (val.length === 2) {
      return ufs.find((e) => val.toUpperCase() === e.sigla);
    } else {
      return false;
    }
  }

  domain(val) {
    if (!val) return false;
    const patternLocal = /^localhost$|^localhost:\d+$/gi;
    if (patternLocal.test(val)) {
      return true;
    } else {
      const pattern = /^(?:[a-z0-9-]{0,61}?\.)+[a-z0-9]{0,61}[a-z0-9]$|^(?:[a-z0-9-]{0,61}?\.)+[a-z0-9]{0,61}[a-z0-9]:[0-9]{1,8}$/gi;
      if (pattern.test(val)) {
        return true;
      } else {
        return false;
      }
    }
  }

  placaVeicular(val) {
    if (!val) return true;

    if (val.length === 7) {
      const pattern = /[a-z]{3}\d{1}[\d\D]{1}\d{2}/gi;
      if (pattern.test(val)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  renavamVeicular(val) {
    if (!val) return true;

    if (val.length === 11) {
      return true;
    } else {
      return false;
    }
  }

  valorMoedaMaiorQueZero(val) {
    if (!val) return false;

    const num = currencyToFloat(val);

    if (num > 0) return true;

    return false;
  }

  dataBR(val) {
    if (val.length === 10) {
      const pattern = /[0-9]{2}\/[0-9]{2}\/[0-9]{4}/gi;
      if (pattern.test(val)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

	nomeCompleto(val) {
    if (!val) return true;
    val = val.trim();
    const countWords = val.split(" ");
    for(const word of countWords){
      if(word.length < 2){
        return false;
      }
    }
		if (countWords.length > 1 && val.length > 4) return true;
		return false;
	}

  telefone(val) {
    if (!val) return true;
    //retira todos os caracteres menos os numeros
    val = val.replace(/\D/g, "");

    if (isNaN(val)) return false;

    //verifica se tem a qtde de numero correto
    if (!(val.length >= 10 && val.length <= 11)) return false;

    //Se tiver 11 caracteres, verificar se começa com 9 o celular
    if (val.length === 11 && parseInt(val.substring(2, 3)) !== 9) return false;

    //verifica se não é nenhum numero digitado errado (propositalmente)
    for (var n = 0; n < 10; n++) {
      //um for de 0 a 9.
      //estou utilizando o metodo Array(q+1).join(n) onde "q" é a quantidade e n é o
      //caractere a ser repetido
      if (val === new Array(11).join(n) || val === new Array(12).join(n)) return false;
    }

    //DDDs validos
    var codigosDDD = [
      11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34, 35, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 53, 54, 55, 61, 62, 64, 63, 65, 66, 67, 68, 69, 71, 73, 74, 75, 77,
      79, 81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 92, 93, 94, 95, 96, 97, 98, 99,
    ];

    //verifica se o DDD é valido
    if (codigosDDD.indexOf(parseInt(val.substring(0, 2))) === -1) return false;

    //E por ultimo verificar se o numero é realmente válido.
    if (val.length === 10 && [2, 3, 4, 5, 7].indexOf(parseInt(val.substring(2, 3))) === -1) return false;

    return true;
  }

  ip (val) {
    const regex = /^(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])$/;
    return regex.test(val);
  }

  configureAddMethods() {
    const cpfCnpj = this.cpfCnpj;
    const telefone = this.telefone;
    const placaVeicular = this.placaVeicular;
    const renavamVeicular = this.renavamVeicular;
    const valorMoedaMaiorQueZero = this.valorMoedaMaiorQueZero;
    const slug = this.slug;
    const domain = this.domain;
    const colorHex = this.colorHex;
    const uf = this.uf;
    const dataBR = this.dataBR;
		const nomeCompleto = this.nomeCompleto;
    const ip = this.ip;

    // const arrayMethods = [
    //   cpfCnpj,
    //   telefone,
    //   placaVeicular,
    //   valorMoedaMaiorQueZero,
    //   slug,
    //   domain,
    //   this.colorHex
    // ];

    // for (const m of arrayMethods) {
    //   this.Yup.addMethod(this.Yup.string, m.name, function (errorMessage) {
    //     return this.test(`test${m.name}`, errorMessage, function (value) {
    //       const { path, createError } = this;
    //       return m(value) || createError({ path, message: errorMessage });
    //     });
    //   });
    // }

    this.Yup.addMethod(this.Yup.string, "cpfCnpj", function (errorMessage) {
      return this.test(`testcpfCnpj`, errorMessage, function (value) {
        const { path, createError } = this;
        return cpfCnpj(value) || createError({ path, message: errorMessage });
      });
    });
    this.Yup.addMethod(this.Yup.string, "telefone", function (errorMessage) {
      return this.test(`testtelefone`, errorMessage, function (value) {
        const { path, createError } = this;
        return telefone(value) || createError({ path, message: errorMessage });
      });
    });
    this.Yup.addMethod(this.Yup.string, "placaVeicular", function (errorMessage) {
      return this.test(`testplacaVeicular`, errorMessage, function (value) {
        const { path, createError } = this;
        return placaVeicular(value) || createError({ path, message: errorMessage });
      });
    });
    this.Yup.addMethod(this.Yup.string, "renavamVeicular", function (errorMessage) {
      return this.test(`testrenavamVeicular`, errorMessage, function (value) {
        const { path, createError } = this;
        return renavamVeicular(value) || createError({ path, message: errorMessage });
      });
    });
    this.Yup.addMethod(this.Yup.string, "valorMoedaMaiorQueZero", function (errorMessage) {
      return this.test(`testvalorMoedaMaiorQueZero`, errorMessage, function (value) {
        const { path, createError } = this;
        return valorMoedaMaiorQueZero(value) || createError({ path, message: errorMessage });
      });
    });

    this.Yup.addMethod(this.Yup.string, "slug", function (errorMessage) {
      return this.test(`testslug`, errorMessage, function (value) {
        const { path, createError } = this;
        return slug(value) || createError({ path, message: errorMessage });
      });
    });

    this.Yup.addMethod(this.Yup.string, "domain", function (errorMessage) {
      return this.test(`testdomain`, errorMessage, function (value) {
        const { path, createError } = this;
        return domain(value) || createError({ path, message: errorMessage });
      });
    });

    this.Yup.addMethod(this.Yup.string, "colorHex", function (errorMessage) {
      return this.test(`testcolorHex`, errorMessage, function (value) {
        const { path, createError } = this;
        return colorHex(value) || createError({ path, message: errorMessage });
      });
    });

    this.Yup.addMethod(this.Yup.string, "uf", function (errorMessage) {
      return this.test(`testuf`, errorMessage, function (value) {
        const { path, createError } = this;
        return uf(value) || createError({ path, message: errorMessage });
      });
    });

    this.Yup.addMethod(this.Yup.string, "dataBR", function (errorMessage) {
      return this.test(`testdataBR`, errorMessage, function (value) {
        const { path, createError } = this;
        return dataBR(value) || createError({ path, message: errorMessage });
      });
    });

		this.Yup.addMethod(this.Yup.string, "nomeCompleto", function (errorMessage) {
      return this.test(`testnomeCompleto`, errorMessage, function (value) {
        const { path, createError } = this;
        return nomeCompleto(value) || createError({ path, message: errorMessage });
      });
    });

    this.Yup.addMethod(this.Yup.string, "ip", function (errorMessage) {
      return this.test(`testIp`, errorMessage, function (value) {
        const { path, createError } = this;
        return ip(value) || createError({ path, message: errorMessage });
      });
    });
  }
}

export default Validation;
